import { Component, DestroyRef, effect, inject, input, InputSignal, signal, ViewChild, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { SHARED_MODULES } from '../../../shared.';
import { PlanogramChatDrawerComponent } from '../planogram-chat-drawer/planogram-chat-drawer.component';
import { ChatService } from '../../services/chat.service';
import { SocketService } from '../../services/socket.service';
import { HumanNumberPipe } from '../../pipes/human-number.pipe';
import { SessionService } from '../../services/session.service';

@Component({
    selector: 'app-planogram-chat-widget[id]',
    templateUrl: './planogram-chat-widget.component.html',
    imports: [PhIconWrapperComponent, PhIconComponent, HumanNumberPipe, ...SHARED_MODULES, PlanogramChatDrawerComponent]
})
export class PlanogramChatWidgetComponent {

    id: InputSignal<number> = input<number>(undefined);
    isManager: WritableSignal<boolean> = signal<boolean>(false);
    planogramName: InputSignal<string> = input<string>('');
    unreadCount: WritableSignal<number> = signal<number>(0);

    @ViewChild(PlanogramChatDrawerComponent) drawer!: PlanogramChatDrawerComponent;

    constructor(
        private sessionService: SessionService,
        private socketService: SocketService,
        private chatService: ChatService,
        private destroyRef: DestroyRef
    ) {
        this.isManager.set(this.sessionService.defaults.isManager);

        this.socketService.chatUnreadCount
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data: { unread: number }): void => {
                this.unreadCount.set(data.unread);
            });

        effect((): void => {
            if (this.id()) {
                this.chatService.id = this.id();
            }
        });
    }

    onOpen(focusMessageId?: number): void {
        if (this.id()) {
            this.chatService.id = this.id();
        }
        this.drawer.onOpen('planogram', focusMessageId);
    }
}